<template>
  <el-container class="body_container">
    <el-header style="height: 50px;padding:0px">
      <el-row type="flex" class="body_title">
        <el-col>用户管理</el-col>
        <el-col style="text-align: right;" >
          <el-form :model="searchVo" :inline="true" size="small">
            <el-form-item>
              <el-button @click="add" type="primary">新增</el-button>
            </el-form-item>
            <el-form-item style="margin: 0px">
              <el-input v-model="searchVo.keyword" auto-complete="off" placeholder="用户名/姓名/角色" style="width: 300px">
                <el-button slot="append" @click="search" icon="el-icon-search"></el-button>
              </el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-header>
    <el-main class="search_result emp_search_result">
      <el-table :data="userData.list">
        <!--<el-table-column prop="id" label="用户ID" width="80px"></el-table-column>-->
        <el-table-column prop="realName" label="姓名" min-width="90px"></el-table-column>
        <el-table-column prop="username" label="用户名" min-width="90px"></el-table-column>
        <el-table-column prop="roles" label="角色" min-width="180px"></el-table-column>
        <el-table-column prop="associationName" label="单位" min-width="150px"></el-table-column>
        <!--<el-table-column prop="email" label="邮箱" min-width="120px"></el-table-column>-->
        <!--<el-table-column prop="mobile" label="手机" min-width="125px"></el-table-column>-->
        <el-table-column label="禁止登录" min-width="86px">
          <template slot-scope="scope">
            <el-switch
            v-if="scope.row.username==='yxkj' || scope.row.username ==='admin'" disabled
            v-model="scope.row.loginDenied"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value="0"
            inactive-value="1"
            @change="changeSwitch(scope.row)">
          </el-switch>
            <el-switch
              v-if="scope.row.username!=='yxkj' && scope.row.username !=='admin'"
              v-model="scope.row.loginDenied"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="0"
              inactive-value="1"
              @change="changeSwitch(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="createdBy" label="创建人" min-width="90px"></el-table-column>
        <el-table-column prop="createdTime" label="创建时间" min-width="175px"></el-table-column>
        <el-table-column prop="handle" label="操作" width="120px">
          <template slot-scope="scope">
            <i class="el-icon-edit" @click="editUser(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>
            &nbsp;
            <i v-if="scope.row.username!=='yxkj'&& scope.row.username!=='admin'" class="el-icon-setting" @click="resetUser(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>
            &nbsp;
            <i v-if="scope.row.username!=='yxkj'&& scope.row.username!=='admin'" class="el-icon-delete" @click="delUser(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-pagination class="page"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :page-size="userData.rows"
                   :current-page="userData.page"
                   layout="prev, pager, next, jumper"
                   :total="userData.total">
    </el-pagination>
    <el-dialog title="用户信息" :visible.sync="userDialog">
      <el-form :model="user" size="small">
        <el-form-item label="姓名" label-width="70px">
          <el-input v-model="user.realName"type="text"></el-input>
        </el-form-item>
        <el-form-item label="用户名" label-width="70px">
          <el-input v-model="user.username"type="text"></el-input>
        </el-form-item>
        <!--<el-form-item label="用户密码"  label-width="70px" prop="password">-->
          <!--<el-input v-model="user.password" type="password"></el-input>-->
        <!--</el-form-item>-->
        <!--<el-form-item label="确认密码:" label-width="70px" prop="rpassword">-->
          <!--<el-input v-model="user.rpassword" size="small" type="password"></el-input>-->
        <!--</el-form-item>-->
        <el-form-item label="角色:" label-width="70px">
          <el-select v-model="valueArr" multiple placeholder="角色">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单位" label-width="70px">
          <!--<el-input v-model="user.associationName" type="text"></el-input>-->
          <el-select v-model="aValue" @change="selectAss" placeholder="单位">
            <el-option
              v-for="item in assOptions"
              :key="item.aValue"
              :label="item.aLabel"
              :value="item.aValue">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机" label-width="70px">
          <el-input v-model="user.mobile" type="text" ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" label-width="70px">
          <el-input v-model="user.email" type="text"></el-input>
        </el-form-item>
        <el-form-item label="登录权限" label-width="70px">
          <el-select v-model="user.loginDenied" placeholder="请选择登录状态" style="width: 240px">
            <el-option label="允许登录" value="0"></el-option>
            <el-option label="禁止登录" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('user')">{{'取消'}}</el-button>
        <el-button type="primary" @click="save">{{'保存'}}</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import user from '@/api/user'
import role from '@/api/role'
import store from '../../store/index'
import association from '@/api/association'
export default {
  name: 'User',
  data() {
    return {
      userData: {
        page: 1,
        rows: 10,
        total: 0,
        list: []
      },
      searchVo: {
        keyword: '',//用户名/姓名/角色
        page: 1,
        rows: 10
      },
      userDialog: false,
      user: {
        id: '',
        realName: '',
        username: '',
        password: '',
        roles: [],
        associationId: '',
        associationName: '',
        mobile: '',
        email: '',
        loginDenied: ''
      },
      updateStatus: false,
      options: [{
        value: 'ROLE_admin',
        label: '管理员'
      }, {
        value: 'ROLE_user',
        label: '普通用户'
      }, {
        value: 'ROLE_test',
        label: '测试用户'
      }],
      valueArr: [],
      roleList: [],
      username: '',
      assOptions: [{
        aValue: '1',
        aLabel: '河南省律师协会'
      }],
      aValue: ''
    }
  },
  methods: {
    reload() {
      user.list({
        keyword: this.searchVo.keyword,
        page: this.searchVo.page,
        rows: this.searchVo.rows
      }).then(res => {
        this.getUserData(res.data.data)
      })
      role.list().then(res => {
        this.getRoleData(res.data.data)
      })
      association.list().then(res => {
        this.getAssData(res.data.data)
      })
    },
    getUserData(userData) {
      this.userData = userData
      let obj = {}
      let arr = []
      let brr = []
      this.userData.list.forEach(item => {
        let roleName = ''
        let object = {}
        item.roles.forEach(childItem => {
          roleName += childItem.name + ','
          object = {
            roleId: childItem.id,
            roleName: childItem.name,
            roleCode: childItem.code
          }
          brr.push(object)
        })
        if (roleName.endsWith(',')) {
          roleName = roleName.substring(0, roleName.length - 1)
        }
        obj = {
          id: item.id,
          realName: item.realName,
          username: item.username,
          password: item.password,
          roles: roleName,
          associationId: item.associationId,
          associationName: item.associationName,
          mobile: item.mobile,
          email: item.email,
          loginDenied: item.loginDenied,
          createdBy: item.createdBy,
          createdTime: item.createdTime
        }
        arr.push(obj)
      })
      brr = brr.removeDuplication()
      for (let i = 0; i< brr.length;i++) {
        let f = 0
        for (let j = 0; j< brr.length;j++) {
          if(brr[i].roleId === brr[j].roleId){
            f++
          }
        }
        if (f>1){
          brr.splice(i,1)
        }
      }
      this.userData.list = arr
      this.roleList = brr
    },
    getRoleData(roleData) {
      let obj = {}
      let brr = []
      roleData.forEach(item => {
        obj = {
          value: item.code,
          label: item.name
        }
        brr.push(obj)
      })
      this.options = brr
    },
    getAssData(assData) {
      let obj = {}
      let brr = []
      assData.forEach(item => {
        obj = {
          aValue: item.id,
          aLabel: item.name
        }
        brr.push(obj)
      })
      this.assOptions = brr
    },
    editUser(row) {
      this.updateStatus = true
      this.userDialog = true
      let arr = []
      if (row.roles.indexOf(',') !== -1) {
        arr = row.roles.split(',')
      } else {
        arr.push(row.roles)
      }
      this.user = {
        id: row.id,
        realName: row.realName,
        username: row.username,
        password: row.password,
        rpassword: row.password,
        roles: arr,
        associationId: row.associationId,
        associationName: row.associationName,
        mobile: row.mobile,
        email: row.email,
        loginDenied: row.loginDenied
      }
      let crr = []
      arr.forEach(item => {
        this.options.forEach(i => {
          if (item === i.label) {
            crr.push(i.value)
          }
        })
      })
      this.valueArr = crr
      this.aValue = row.associationId
    },
    delUser(row) {
      this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        user.delUser({id: row.id}).then(res => {
          if (res.data.code===0) {
            this.$message({
              type: 'success',
              message: res.data.message
            });
            this.reload()
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    resetUser (row) {
      this.$confirm('此操作将重置该用户的密码, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        user.resetPwd({id: row.id}).then(res => {
          if (res.data.code===0) {
            this.$message({
              type: 'success',
              message: res.data.message
            });
            this.reload()
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消重置'
        });
      });
    },
    handleSizeChange(val) {
      this.searchVo.page = val
      this.reload()
    },
    handleCurrentChange(val) {
      this.searchVo.page = val
      this.reload()
    },
    search() {
      this.searchVo.page=1
      this.reload()
    },
    save() {
      let arr = []
      let obj = {}
      this.valueArr.forEach(item => {
        this.roleList.forEach(i => {
          if (item === i.roleCode) {
            obj = {
              id: i.roleId
            }
            arr.push(obj)
          }
        })
      })
      this.user.roles = arr
      this.user.password = '123456' //初始密码
      this.user.associationId = this.aValue
      // console.log(this.user)
      user.saveUser(this.user).then(res => {
        if (res.data.code===0) {
          this.$message({
            type: 'success',
            message: res.data.message
          });
          this.userDialog = false
          this.user = {}
          this.valueArr = []
          this.reload()
        } else {
          this.$message({
            type: 'error',
            message: res.data.message
          });
        }
      })
    },
    cancel() {
      this.userDialog = false
      this.user = {}
    },
    changeSwitch(row) {
      user.denyLogin({id: row.id, loginDenied: row.loginDenied}).then(res => {
        alert(res.data.message)
      })
    },
    add() {
      this.user = {}
      this.valueArr = []
      this.aValue = ''
      this.userDialog = true
      this.updateStatus = false
    },
    selectAss (val) {
      this.aValue = val
    }
  },
  created() {
    //去除list重复
    Array.prototype.removeDuplication = function(){
      let res = [];
      let json = {};
      for(let i = 0; i < this.length; i++){
        if(!json[this[i].roleId]){
          res.push(this[i]);
          json[this[i].roleId] = 1;
        }
      }
      return res;
    }
    this.reload()
    if (store.getters.getUsername) {
      this.username = store.getters.getUsername
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/system/User.vue